import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  ProfileDataActions,
  ProfileDataPipes,
  ProfileDataSelectors,
  ProfileDeleteActions,
  ProfileDeleteSelectors,
} from './profile-data.feature';
import { Observable } from 'rxjs';
import { PageDataState } from '../../page-data/page-data.types';
import { Profile } from 'src/app/shared/entities/profile';

@Injectable({
  providedIn: 'root',
})
export class ProfileDataService {
  private store = inject(Store);

  data$: Observable<Profile[] | null> = this.store.pipe(
    ProfileDataPipes.selectData,
  );

  isLoading$: Observable<boolean> = this.store.select(
    ProfileDataSelectors.selectIsLoading,
  );

  isLoaded$: Observable<boolean> = this.store.select(
    ProfileDataSelectors.selectIsLoaded,
  );
  isError$: Observable<boolean> = this.store.select(
    ProfileDataSelectors.selectIsError,
  );
  state$: Observable<PageDataState<void, Profile[]>> = this.store.select(
    ProfileDataSelectors.selectPageDataState,
  );

  isDeleting: Observable<boolean> = this.store.select(
    ProfileDeleteSelectors.isDeleting,
  );

  ensure(options?: { suppressErrorNotification?: boolean }) {
    this.store.dispatch(
      ProfileDataActions.ensure({
        dataParams: undefined,
        suppressErrorNotification: options?.suppressErrorNotification,
      }),
    );
  }

  clear() {
    this.store.dispatch(ProfileDataActions.clear());
  }

  transform(transformation: (data: Profile[]) => Profile[]) {
    this.store.dispatch(ProfileDataActions.transform({ transformation }));
  }

  delete(profile: Profile, options?: { suppressNotifications?: boolean }) {
    this.store.dispatch(
      ProfileDeleteActions.delete({ item: profile, options }),
    );
  }
}
